import CheckEmailModal from "features/Modal/Modals/CheckEmailModal";
import UnexpectedErrorModal from "features/Modal/Modals/UnexpectedErrorModal";
import React from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { ModalTypes } from "./modalTypes";
import { setModal } from "./slice";

function ModalProvider() {
  const dispatch = useAppDispatch();
  const currentModal = useAppSelector((state) => state.modal.currentModal);

  const closeModal = () => {
    dispatch(setModal(null));
  };

  if (!currentModal) {
    return null;
  }

  const { modalProps } = currentModal;

  switch (currentModal.type) {
    case ModalTypes.CheckEmail:
      return (
        <CheckEmailModal closeModal={closeModal} email={modalProps?.email} />
      );
    case ModalTypes.UnexpectedError:
      return <UnexpectedErrorModal closeModal={closeModal} />;
  }
}

export default ModalProvider;
